const Loader = () => {
  return (
    <div className="animationload">
      <div className="loader"></div>
    </div>
  )
}

export default Loader


